import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiGetLessorClientServiceFeeCases,
    apiGetIotProvidersList,
} from 'services/CommonService'

export const getLessorClientServiceFeeCases = createAsyncThunk(
    'base/common/apiGetLessorClientServiceFeeCases',
    async () => {
        const response = await apiGetLessorClientServiceFeeCases()
        // 格式化資料，讓 Select 元件使用
        // [{ case: "1", description: "不收費", name: "方案 A" }]
        // => [{ value: "1", label: "方案 A", description: "不收費" }]
        const options = response.data.data.map((item) => ({
            value: item.case,
            label: item.name,
            description: item.description,
        }))
        return options
    }
)

export const getIotProvidersList = createAsyncThunk(
    'base/common/apiGetIotProvidersList',
    async () => {
        const response = await apiGetIotProvidersList()

        return response?.data?.providers || []
    }
)

/**
 * @type {object}
 * @property { 'contract-note-dialog' } globalDialog - 彈窗類別
 */
export const initialState = {
    currentRouteKey: '',
    orgsTags: [],
    globalDialog: false,
    allContractTemplateTypesNewstData: [],
    landlordRecords: [],
    repairItems: [],
    clientServiceFeeCasesOptions: [],
    iotProvidersList: [], // IoT供應商列表
    customerExitDialog: false,
    resubmitConfirmData: {
        // 企業資料補件
        isOpen: false,
        id: '',
    },
    workSpaceToolsData: {
        isOpen: false,
        id: '',
        walletDetailData: {},
    },
}

export const commonSlice = createSlice({
    name: 'base/common',
    initialState,
    reducers: {
        setCurrentRouteKey: (state, action) => {
            state.currentRouteKey = action.payload
        },
        setOrgsTags: (state, action) => {
            state.orgsTags = action.payload
        },
        setCountryCity: (state, action) => {
            state.cityData = action.payload.countries
        },
        toggleGlobalDialog: (state, action) => {
            state.globalDialog = action.payload
        },
        setAllContractTemplateTypesNewstData: (state, action) => {
            state.allContractTemplateTypesNewstData = action.payload
        },
        setLandlordRecords: (state, action) => {
            state.landlordRecords = action.payload
        },
        setRepairItems: (state, action) => {
            state.repairItems = action.payload
        },
        setCustomerExitDialog: (state, action) => {
            state.customerExitDialog = action.payload
        },
        setResubmitConfirmData: (state, action) => {
            state.resubmitConfirmData = {
                ...state.resubmitConfirmData,
                ...action.payload,
            }
        },
        setWorkSpaceToolsData: (state, action) => {
            state.workSpaceToolsData = {
                ...state.workSpaceToolsData,
                ...action.payload,
            }
        },
    },
    extraReducers: {
        [getLessorClientServiceFeeCases.fulfilled]: (state, action) => {
            state.clientServiceFeeCasesOptions = action.payload
        },
        [getIotProvidersList.fulfilled]: (state, action) => {
            state.iotProvidersList = action.payload
        },
    },
})

export const selectOpenDialog = (state) => state.base.common.globalDialog

export const selectDeviceOptions = (state) => {
    const repairItems = state.base.common.repairItems

    const flatMapDeviceList = repairItems.flatMap((item) => item.deviceList)

    const deviceOptions = flatMapDeviceList.map((item) => ({
        value: item.id,
        label: item.display_name,
    }))

    return [{ value: undefined, label: '設備' }, ...deviceOptions]
}

export const {
    setCurrentRouteKey,
    setOrgsTags,
    setCountryCity,
    toggleGlobalDialog,
    setAllContractTemplateTypesNewstData,
    setLandlordRecords,
    setRepairItems,
    setCustomerExitDialog,
    setResubmitConfirmData,
    setWorkSpaceToolsData,
} = commonSlice.actions

export default commonSlice.reducer
